exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".qrcode {\n  width: 100%;\n  padding-top: 5.33333vw;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n", ""]);
